<template>
  <v-card class="blue-grey lighten-5">
    <v-overlay :value="playerStatus === 'ready'" absolute />

    <v-card-title
      :class="isConnected ? 'accent--text' : 'secondary--text'"
      class="headline justify-center"
      v-text="playerName"
    />

    <v-card-text class="text-center">
      <div
        :class="statusColor"
        class="mt-3 mb-2 py-1 px-2 rounded-pill subtitle-1 white--text lighten-1"
      >
        <div class="pre-formatted" v-text="statusText" />
      </div>

      <!-- eslint-disable-next-line -->
      <div class="ma-5 player-svg" v-html="value.tangram" />
    </v-card-text>

    <template v-if="numberOfInstructions">
      <v-divider />

      <div class=" py-1 text-center" v-text="instructionText" />
    </template>
  </v-card>
</template>

<script>
export default {
  name: 'PlayerCard',
  props: {
    value: {
      type: Object,
      required: true,
    },
    numberOfInstructions: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    currentTimestamp: Date.now(),
  }),
  computed: {
    playerId () {
      return this.value.id
    },
    isConnected () {
      return this.value.playerName
    },
    playerName () {
      return this.isConnected
        ? this.value.playerName
        : this.$t('animation.networkdiagram.notPlayerName')
    },
    playerStatus () {
      return this.value.status
    },
    statusColor () {
      return {
        ready: 'accent',
        playing: 'success',
        finished: 'secondary',
      }[this.playerStatus]
    },
    statusText () {
      if (this.playerStatus === 'playing') {
        const duration = Math.round((this.currentTimestamp - this.value.startPlayingTime) / 1000)
        return this.$tc('animation.networkdiagram.status.playing', Math.trunc(duration / 60), {
          minutes: Math.trunc(duration / 60),
          seconds: duration % 60,
        })
      }

      if (this.playerStatus === 'finished') {
        const { startPlayingTime, stopPlayingTime } = this.value
        const duration = Math.round((stopPlayingTime - startPlayingTime) / 1000)

        return duration
          ? this.$tc('animation.networkdiagram.status.finished', Math.trunc(duration / 60), {
            minutes: Math.trunc(duration / 60),
            seconds: duration % 60,
          })
          : this.$tc('animation.networkdiagram.status.noPlayed')
      }

      return this.$t(`animation.networkdiagram.status.${this.playerStatus}`)
    },
    instructionText () {
      const current = this.value.currentInstruction
      const total = this.numberOfInstructions
      return this.$t('animation.networkdiagram.instructionStep', { current, total })
    },
  },
  mounted () {
    this.$timestampInterval = setInterval(() => {
      this.currentTimestamp = Date.now()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.$timestampInterval)
  },
}
</script>

<style lang="scss" scoped>
  .pre-formatted {
    white-space: pre;
  }

  .player-svg {
    user-select: none;
  }
</style>
